import styled from 'styled-components';

export const Message = styled.p`
  color: ${({ theme }) => theme.colors['neutral-100']};
  font-size: 14px;
  line-height: 150%;
`;
